import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengeplank() {
  return (
    <section className="challenge_plank p-100 text_whitegreen back_black">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="problem_img">
              <StaticImage
                src="../../../images/case-studies/pure-plank/challenges.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={629}
                height={665}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>Challenges & Solutions</h2>
            <p>
              When we got this idea from our client and proposed a solution, it
              was not without challenges and opportunities. The first
              opportunity was that there was no similar app on the idea that we
              had chosen to build the app, and this turned out to be our biggest
              challenge.
            </p>
            <p>
              After careful analysis and understanding, we built the
              application, keeping in mind the experience of the end users. We
              build the application with several amazing features and functions
              to assist the users and deliver long-term value. Our experts
              successfully build the solution as per the client’s instructions.
            </p>
            <p>
              The Plank app is a complete solution surrounding the planking
              exercise where users get all the functions and features in one
              place to get the ideal results. The app also had video tutorials
              and instructions for the users, as well as the option to buy
              accessories with complete payment integration options.
            </p>
            <p>
              Moreover, the users can maintain their profiles, get timely
              notifications, check their progress, payment and order history,
              payment processing, and more. All in all, the app serves as a
              complete solution for anyone to explore, plan exercise and be fit
              at home.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengeplank;
